module.exports = __webpack_public_path__ + "img/section-title4.f5e318d0.png";